// import React from 'react'
import { EditOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { ButtonCommon } from '..'

const ActionCommon = ({ onEditClick, record }) => {
	const handleEdit = () => {
		onEditClick && onEditClick(record)
	}
	return (
		<div>
			<ButtonCommon onClick={handleEdit}>
				<EditOutlined />
			</ButtonCommon>
		</div>
	)
}

ActionCommon.propTypes = {
	onEditClick: PropTypes.func,
	record: PropTypes.any,
}

export default ActionCommon
